// extracted by css-extract-rspack-plugin
export default {"content":"oEj3qbp___content","list":"fCEbYkf___list"};